var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseNav'),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content d-flex justify-content-center align-items-center"},[(_vm.loading)?_c('base-loading'):_vm._e()],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }